import React from 'react';
import { sanitizeHTML } from '../../utilities/sanitizeHTML';

export default ({ suggestion }) => {
    const {
        assignable, requester, title, description, suggestion_type, source,
    } = suggestion;
    const requestText = source === 'seed'
        ? ' suggested a page'
        : suggestion_type === 'new' ? ' requested a new page' : ' requested an update';

    const requesterName = source === 'seed' ? 'Tettrabot' : requester.display_name;
    const requesterAvatar = source === 'seed' ? '/img/kai.png' : requester.image_192;
    const sanitizedHtml = sanitizeHTML(description);

    return (
        <div className="inline-suggestion">
            <div className="flex">
                <div className="flex-none mr1">
                    <img
                        className="left post-avatar"
                        src={requesterAvatar}
                        width="28"
                        height="28"
                        alt="requester avatar"
                    />
                </div>
                <div className="flex-auto gray">
                    <span className="black bold">{requesterName}</span>
                    {requestText}
                </div>
            </div>
            { suggestion_type === 'new' && <h4 className="m0 mt2">{title}</h4> }
            <p className="mb0 mt1" dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
        </div>
    );
};
